














import Vue from "vue";

export default Vue.extend({
  props: ['order'],
  computed: {
    checkboxesInfoArray(): Array<{text: string, fullText: string, status: string}> {
      if (this.order.params.checkbox) {
        return JSON.parse(this.order.params.checkbox);
      }
      return [];
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    show(event: MouseEvent, index: number) {
      event.preventDefault();
      event.stopPropagation(); // Остановка всплытия события

      let $checkbox = $(`#show_checkbox_${this.order.id}_${index}`);
      $('.checkbox__modal').not($checkbox.find('.checkbox__modal')).fadeOut(300); // Скрываем все кроме текущего
      $checkbox.find('.checkbox__modal').fadeToggle(300);
    },
    handleClickOutside(event: MouseEvent) {
      const targetElement = event.target as Element;

      if (!targetElement.closest('.checkbox__link')) {
        $('.checkbox__modal').fadeOut(300);
      }
    },
    stripTags(text: string) {
      return text.replace(/<\/?[^>]+(>|$)/g, "");
    },
  }
})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/backend/components/table/fields/CheckboxesField.vue